<template lang="pug">
.product-container(:class="{'filter-black': add}")
  .product-gallery
    .image-wrapper.relative
      shGallery(:images="product.images" :imagePath="imagePath" :folder="`${product.brand}/${product.folder}`" :subfolder="product.subfolder" :alt="product.product" classImage="product-image")
      .show-details-reference(v-if="!hideDescription")
        .arrow-alone(:class="{'isLoading': description.isLoading, 'isShow': description.show}" @click="toggleDescription(product)")
    .product-description-panel(v-if="!hideDescription && description.show")
      .description-product {{ description.text }}
      .description-measurements-text(v-if="description.measurementsText") {{ description.measurementsText }}
  .header-product
    .product-title.uppercase
      div {{ product.product }} - {{ product.colors[0] }}
      .details-number(v-if="productQuantity") {{ productQuantity }} - {{ money(productSubtotal) }}

  .product-details.center
    .product-quantity-order-container(v-for="(size, index) in product.sizes" v-if="product.quantityCart && product.quantityCart[index]" :class="{'paid': order && order.status === 'paid'}")
      .product-quantity-order
        .uppercase Talla {{ size }}
        .cart-quantity-order(:class="{'cart-quantity-order--packed': isPaidPickProgressStatus}")
          span.refund-qty-chips(v-if="refundShowsSplit(index)")
            a.refund-qty-chip.refund-qty-chip--bonus(v-if="quantityBonusForSize(index) && refundListOrderId" :href="bonusesFilteredHref" target="_blank" rel="noopener noreferrer" title="Bonos de clientes filtrados por esta orden") {{ quantityBonusForSize(index) }}
            span.refund-qty-chip.refund-qty-chip--bonus(v-else-if="quantityBonusForSize(index)" title="Bonos reservados (sin orden en contexto)") {{ quantityBonusForSize(index) }}
            a.refund-qty-chip.refund-qty-chip--transfer(v-if="quantityTransferForSize(index) && refundListOrderId" :href="refundsFilteredHref" target="_blank" rel="noopener noreferrer" title="Reembolsos filtrados por esta orden") {{ quantityTransferForSize(index) }}
            span.refund-qty-chip.refund-qty-chip--transfer(v-else-if="quantityTransferForSize(index)" title="Transferencia / reembolso (sin orden en contexto)") {{ quantityTransferForSize(index) }}
          a.refund-qty-chip.refund-qty-chip--transfer(v-else-if="refundedQuantityForSize(index) && refundListOrderId" :href="refundsFilteredHref" target="_blank" rel="noopener noreferrer" title="Reembolsos filtrados por esta orden") {{ refundedQuantityForSize(index) }}
          span.refund-qty-chip.refund-qty-chip--transfer(v-else-if="refundedQuantityForSize(index)" title="Unidades en reembolso") {{ refundedQuantityForSize(index) }}
          .picked-label(v-if="!pick || !product.picked") {{ product.quantityCart[index] }}
          .picked-label(v-else :class="pickProgressClass(index)") {{ product.picked[index] ? product.picked[index].length : 0 }} | {{ product.quantityCart[index] }}
          shContextMenu(v-if="sizeContextMenuItems.length" :items="sizeContextMenuItems" @select="onSizeMenuSelect($event, product, size, index)")

      div(v-if="pick && !hidePack")
        shTierList(
          v-if="product.picked[index] && product.picked[index].length > 0"
          title="Listos"
          :tiers="product.picked[index]"
          :clickable="true"
          :action="unpickProduct"
          :buildParams="(group) => [product.product, size, group.tier, group.indices[0]]"
          :isCheckedFn="(group) => isPickedGroupChecked(product, index, group)"
          :reviewedCornerCheck="true"
        )

        shTierList(
          v-if="allowPick"
          title="Niveles"
          :tiers="tiers[size]"
          :clickable="true"
          :nameProduct="product.product"
          :size="size"
          :brand="product.brand"
          :enable="showLastTier(size)"
          :action="pickProduct"
          :buildParams="(group) => [product.product, size, group.tier, group.indices[0]]"
          :disabledFn="(group) => !isTierAvailable(size, group.indices[0])"
          @deleted="seeTiers(product)"
          @added="seeTiers(product)"
          @enable="onTierStockEnable(size, $event)"
        )

  .product-details.center(v-if="add")
    .product-quantity-order-container(v-for="(size, index) in product.sizes" v-if="product.quantityAvailable")
      .product-quantity-order
        div
          span Talla
          span.uppercase  {{ size }}
        div.cart-quantity-order(:class="{'cart-quantity-order--packed': isPaidPickProgressStatus}")
          span {{ product.quantityAvailable[index] }}
      .right.fix-10
        shActionButton(v-if="product.quantityAvailable[index] && !hideAddAndSubtract" :action="addOne" :params="[product, size, index]" text="+1" textRunning="+1")

  .change-price(v-if="!hideAddAndSubtract && ((change && change.status === 'created') || (order && order.status === 'created')) && !hideChangePrice")
    .input-container
      input.input(v-model.number="newPrice" autocomplete="ño")
      label.label(:class="{ show: newPrice >= 0 }") Precio
    shActionButton(:action="updatePriceProduct" text="Actualizar" textRunning="Actualizando")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import shGallery from '@/components/ecommerce/Gallery'
import gql from '@my/graphql'
import gqlOrder from '@/graphql/order'
import gqlChange from '@/graphql/change'
import gqlProduct from '@/graphql/product'
import modals from '@my/store/modals'
import { getBaseTierByBrand } from '@/helpers/tier'
import shTierList from '@/components/elements/TierList'
import shContextMenu from '@/components/elements/ContextMenu'

export default {
  name: 'ProductOrder',

  mixins: [mForm, mFilters],

  inject: {
    chooseUnpickReturnTier: { default: null },
    chooseChangeSize: { default: null }
  },

  components: { shGallery, shTierList, shContextMenu },

  props: {
    product: Object,
    order: Object,
    change: Object,
    quantity: Number,
    add: Boolean,
    subtract: Boolean,
    pick: Boolean,
    allowPick: {
      type: Boolean,
      default: true
    },
    isChange: Boolean,
    isProductChange: Boolean,
    hideAddAndSubtract: Boolean,
    hidePack: Boolean,
    hideDescription: Boolean,
    hideChangePrice: Boolean,
    quantitySale: Number
  },

  data () {
    return {
      imagesPersons: { man: { person: 'man', folder: 'images', image: 'man.svg' }, woman: { person: 'woman', folder: 'images', image: 'woman.svg' } },
      tiers: {},
      showLast: {},
      newPrice: '',
      description: {
        show: false,
        text: '',
        measurementsText: '',
        isLoading: false
      },
      protectedTiers: 3
    }
  },

  mounted () {
    if (!this.hidePack) this.seeTiers(this.product)
  },

  methods: {
    refundedQuantityForSize (sizeIndex) {
      const n = this.product.refundedQuantity && this.product.refundedQuantity[sizeIndex]
      return n > 0 ? n : 0
    },

    quantityBonusForSize (sizeIndex) {
      const n = this.product.quantityBonus && this.product.quantityBonus[sizeIndex]
      return n > 0 ? n : 0
    },

    quantityTransferForSize (sizeIndex) {
      const n = this.product.quantityTransfer && this.product.quantityTransfer[sizeIndex]
      return n > 0 ? n : 0
    },

    refundShowsSplit (sizeIndex) {
      return this.quantityBonusForSize(sizeIndex) > 0 || this.quantityTransferForSize(sizeIndex) > 0
    },

    pickProgressClass (index) {
      if (!this.isPaidPickProgressStatus) return {}
      const pickedLen = this.product.picked[index] ? this.product.picked[index].length : 0
      const cartQty = this.product.quantityCart[index]
      return {
        'color-red': pickedLen < cartQty,
        'color-green': pickedLen >= cartQty
      }
    },

    isTierAvailable (size, indexTier) {
      if (this.isMoreThanThreeTiers(size)) return true
      if (this.showLastTier(size)) return true
      return false
    },
    showLastTier (size) {
      return this.showLast[size]
    },
    isMoreThanThreeTiers (size) {
      return this.tiers[size].length > this.protectedTiers
    },
    isProductChecked (product, indexSize, indexTier) {
      if (!product.checked) return false
      if (!product.checked[indexSize]) return false
      const value = product.checked[indexSize][indexTier]
      if (value == null || value === false || value === 'false') return false
      return value === true || value === 'true'
    },
    isPickedGroupChecked (product, indexSize, group) {
      return group.indices.every(indexTier => this.isProductChecked(product, indexSize, indexTier))
    },

    async subtractAndClose (product, size, index) {
      await this.subtractOne(product, size, index)
    },

    onSizeMenuSelect (item, product, size, index) {
      if (item.action === 'subtract') return this.subtractAndClose(product, size, index)
      if (item.action === 'changeSize') return this.changeSize(product, size, index)
    },

    getPickedTierForSize (product, index) {
      if (!product.picked || !product.picked[index] || !product.picked[index].length) return ''
      const picked = product.picked[index]
      return picked[picked.length - 1]
    },

    async changeSize (product, size, index) {
      if (!this.chooseChangeSize || !this.order) return

      try {
        await this.chooseChangeSize({
          product: product.product,
          fromSize: size,
          sizeIndex: index,
          brand: product.brand || this.order.brand,
          folder: product.folder,
          subfolder: product.subfolder,
          images: product.images,
          pickedFromTier: this.getPickedTierForSize(product, index)
        })
      } catch (_) {
        return
      }
    },

    priceProduct (order, product) {
      let price = product.priceUnit
      if (order.isDropshipping || order.isWholesaler) {
        price = product.priceWholesaler
      } else if (order.saleByUnit && product.isClearence) {
        price = product.priceSale
      } else if (order.saleByUnit && order.isSale) {
        price = product.priceSale
      } else if (product.isClearence) {
        price = product.priceSale
      } else if (order.isSale) {
        if (order.isCommunity) {
          price = product.priceSaleCommunity
        } else {
          price = product.priceSale
        }
      } else if (this.quantity >= this.quantitySale && !order.saleByUnit) {
        if (order.isCommunity) {
          price = product.priceThreeCommunity
        } else {
          price = product.priceThree
        }
      } else {
        price = product.priceUnit
      }
      return price
    },

    async addOne (product, size, index) {
      const mutation = this.isChange ? gqlChange.ADD_PRODUCT : gqlOrder.ADD_PRODUCT
      const options = { product: product.product, size, quantity: 1 }
      if (!this.isChange) options.order = this.order.order
      if (this.isChange) options.change = this.change.change

      const response = await gql.mutate(mutation, options)

      if (response) {
        modals.showMessage({ message: `Se agregó el producto ${product.product} correctamente` })
        this.$emit('updateProduct', { product: product.product, index, quantity: 1 })
      }
    },

    async subtractOne (product, size, index) {
      const mutation = this.isChange ? gqlChange.SUBTRACT_PRODUCT : gqlOrder.SUBTRACT_PRODUCT
      const options = { product: product.product, size, quantity: 1 }
      if (!this.isChange) options.order = this.order.order
      if (this.isChange) options.change = this.change.change

      const response = await gql.mutate(mutation, options)

      if (response) {
        modals.showMessage({ message: `Se restó el producto ${product.product} correctamente` })
        this.$emit('updateProduct', { product: product.product, index, quantity: -1 })
      }
    },

    async updatePriceProduct () {
      const mutation = this.isChange ? gqlChange.UPDATE_PRICE_PRODUCT : gqlOrder.UPDATE_PRICE_PRODUCT
      const optionsChange = this.isChange ? { change: this.change.change, product: this.product.product, price: this.newPrice || 0 } : undefined
      const optionsOrder = !this.isChange ? { order: this.order.order, product: this.product.product, price: this.newPrice || 0 } : undefined
      const options = this.isChange ? optionsChange : optionsOrder

      const response = await gql.mutate(mutation, options)

      if (response) {
        modals.showMessage({ message: `Se actualizó el precio (${this.newPrice}) del producto ${this.product.product} correctamente` })
      }
    },

    async seeTiers (product) {
      const mutation = gqlProduct.GET_TIERS_BY_PRODUCT
      const options = { product: product.product }

      const response = await gql.mutate(mutation, options)

      if (response && response.data && response.data.getByProduct) {
        const data = response.data.getByProduct

        if (data.sizes && data.tiers && Array.isArray(data.showLast)) {
          data.sizes.forEach((size, index) => {
            this.$set(this.tiers, size, data.tiers[index])
            this.$set(this.showLast, size, data.showLast[index])
          })
        }
      }
    },

    onTierStockEnable (size, enable) {
      this.$set(this.showLast, size, enable)
      this.seeTiers(this.product)
    },

    async pickProduct (product, size, tier, indexTier) {
      if (!this.allowPick) return
      await this.seeTiers(this.product)
      const quantityTiers = this.tiers[size].length

      if (quantityTiers <= 3 && !this.showLast[size]) {
        modals.showMessage({ message: `Antes de alistar un producto verifica que existe el último producto`, type: 'error' })
        return
      }

      const mutation = this.isProductChange
        ? gqlOrder.PICK_PRODUCT_CHANGE_ORDER
        : (this.isChange ? gqlChange.PICK_PRODUCT_CHANGE : gqlOrder.PICK_PRODUCT_ORDER)
      const options = { product, tier, size }
      if (this.isProductChange || !this.isChange) options.order = this.order.order
      if (this.isChange && !this.isProductChange) options.change = this.change.change

      const response = await gql.mutate(mutation, options)

      if (response) {
        this.tiers[size].splice(indexTier, 1)
        modals.showMessage({ message: `Se alistó el producto ${product} en talla ${size} en el nivel ${tier} ${this.isProductChange ? `del cambio de la orden ${this.order.order}` : (this.change ? `del cambio ${this.change.change}` : `de la orden ${this.order.order}`)} correctamente` })
      }
    },

    async unpickProduct (product, size, tier, indexTier) {
      const brand = this.product.brand || (this.order && this.order.brand) || (this.change && this.change.brand)
      let returnTier = getBaseTierByBrand(brand)

      if (this.chooseUnpickReturnTier) {
        try {
          returnTier = await this.chooseUnpickReturnTier({
            product,
            size,
            pickedTier: tier,
            brand,
            folder: this.product.folder,
            subfolder: this.product.subfolder,
            images: this.product.images
          })
        } catch (_) {
          return
        }
      }

      const mutation = this.isProductChange
        ? gqlOrder.UNPICK_PRODUCT_CHANGE_ORDER
        : (this.isChange ? gqlChange.UNPICK_PRODUCT_CHANGE : gqlOrder.UNPICK_PRODUCT_ORDER)
      const options = { product, tier, size, returnTier }
      if (this.isProductChange || !this.isChange) options.order = this.order.order
      if (this.isChange && !this.isProductChange) options.change = this.change.change

      const response = await gql.mutate(mutation, options)

      if (response) {
        if (this.tiers[size]) this.tiers[size].push(returnTier)
        modals.showMessage({ message: `Se desalistó el producto ${product} en talla ${size} en el nivel ${returnTier} ${this.isProductChange ? `del cambio de la orden ${this.order.order}` : (this.change ? `del cambio ${this.change.change}` : `de la orden ${this.order.order}`)} correctamente` })
      }
    },

    async toggleDescription (product) {
      if (this.description.show) {
        this.description.show = false
        this.description.text = ''
        this.description.measurementsText = ''
        this.description.isLoading = false
        return true
      }

      this.description.isLoading = true

      const mutation = gqlProduct.GET_BY_PRODUCT
      const options = { product: product.product }

      const response = await gql.mutate(mutation, options)

      if (!response || !response.data || !response.data.getByProduct) {
        this.description.isLoading = false
        return false
      }

      const data = response.data.getByProduct
      this.description.text = data.description
      const mt = data.measurementsText
      this.description.measurementsText = (mt && String(mt).trim()) || ''
      this.description.show = true
      this.description.isLoading = false

      return true
    }
  },

  computed: {
    productQuantity () {
      if (this.product.productQuantity) return this.product.productQuantity
      if (!this.product.quantityCart) return 0
      const quantity = this.product.quantityCart.reduce((a, b) => a + b, 0)
      return quantity
    },
    productSubtotal () {
      if (this.product.productSubtotal) return this.product.productSubtotal
      if ( this.change && this.change.isSale) return this.product.priceSale * this.productQuantity
      return this.product.priceUnit * this.productQuantity
    },
    /** Pedido pagado (fase de alistamiento/empaque): color cantidad + progreso pick */
    isPaidPickProgressStatus () {
      if (this.order && this.order.status === 'paid') return true
      if (this.change && this.change.status === 'paid') return true
      return false
    },
    /** Origen de orden para filtros URL (pedido directo o cambio con mismo campo `order`) */
    refundListOrderId () {
      const fromOrder = this.order && this.order.order
      if (fromOrder) return fromOrder
      const fromChange = this.change && this.change.order
      return fromChange || null
    },
    bonusesFilteredHref () {
      if (!this.refundListOrderId) return '#'
      return this.$router.resolve({
        path: '/bonuses',
        query: { Order: this.refundListOrderId }
      }).href
    },
    refundsFilteredHref () {
      if (!this.refundListOrderId) return '#'
      return this.$router.resolve({
        path: '/refunds',
        query: { Order: this.refundListOrderId }
      }).href
    },

    sizeContextMenuItems () {
      const items = []

      if (this.subtract && !this.hideAddAndSubtract) {
        items.push({ label: 'Restar 1', action: 'subtract' })
      }

      if (this.order && this.canChangeSize) {
        items.push({ label: 'Cambiar talla', action: 'changeSize' })
      }

      return items
    },

    canChangeSize () {
      if (!this.order || this.isChange || this.isProductChange) return false
      return ['created', 'approved', 'paid', 'packed', 'sent'].includes(this.order.status)
    }
  },

  watch: {
    'order.status': {
      handler (newVal, oldVal) {
        if (newVal === 'paid' && oldVal === 'approved') {
          this.seeTiers(this.product)
        }
      }
    }
  }
}
</script>

<style lang="stylus">
@import '~@/stylus/product.styl'

.product-quantity-order-container
  border-bottom 1px solid rgba(255,255,255,0.2)
  borderRadius(1.5em)
  margin 1.5rem 0

.product-quantity-order-container.paid
  margin 2rem 0 4rem 0

.product-quantity-order
  font-size 1.3rem
  display flex
  justify-content space-between
  align-items center

.cart-quantity-order
  font-size 1.3em
  color inherit
  display inline-flex
  gap 1rem
  align-items center

.cart-quantity-order--packed
  color #FF5968

.cart-quantity-order .tag
  font-size 1.3rem

.refund-qty-chips
  display inline-flex
  align-items center
  gap .5rem

.refund-qty-chip
  display inline-flex
  align-items center
  justify-content center
  min-width 1.5em
  padding .15em .4em
  border-radius .35em
  font-size 1.3rem
  font-weight 600
  line-height 1.2

a.refund-qty-chip
  text-decoration none
  cursor pointer
  &:hover
    filter brightness(0.97)

.refund-qty-chip--bonus
  background #b3e5fc
  color #0277bd

.refund-qty-chip--transfer
  background #ffcdd2
  color #c62828

.picked-label
  font-size 1.3rem
  font-weight 600

.color-green
  color #4CAF50

.add-text
  font-size .8em

.filter-black
  filter grayscale(10%)
  opacity .5

.change-price
  display flex
  align-items center
  gap 1rem
  padding 1em


.show-details-reference
  position absolute
  bottom .8rem
  right 1.2rem
  z-index 10

.product-description-panel
  text-align left
  margin 1rem 1rem 2rem 1rem
  font-size .95em
  opacity .9
  white-space pre-wrap

.description-product
  margin 0

.description-measurements-text
  margin-top .75rem

.header-product
  display flex
  justify-content space-between
  align-items center
  margin 1rem
  gap 1rem

// Animation is loading description
.isLoading
  animation loading 2s infinite

@keyframes loading
  0%
    border-color var(--color-placeholder)
  50%
    border-color rgb(255, 255, 255)
  100%
    border-color var(--color-placeholder)
</style>



// WEBPACK FOOTER //
// src/components/ecommerce/Product.vue